/**
 * Correspondência por nome (contém) ou documento (dígitos), igual AgendaScreen (mobile).
 * @param {{ nome?: string, documentoVisitante?: string }} item — linha da agenda normalizada
 * @param {string} termo
 */
export function itemCorrespondePesquisaVisitanteMobile(item, termo) {
  const raw = String(termo || "").trim();
  if (raw.length < 2) return false;
  const nome = String(item.nome || "").toLowerCase();
  const tl = raw.toLowerCase();
  if (nome.includes(tl)) return true;
  const docItem = String(item.documentoVisitante || "").replace(/\D/g, "");
  const docQ = raw.replace(/\D/g, "");
  if (docQ.length >= 2 && docItem.length > 0 && docItem.includes(docQ)) return true;
  return false;
}
